import { TIdToPageMap } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioArch71 } from './pages'

export const ID_TO_PAGE_MAP_STYLIO_ARCH_71: TIdToPageMap = {
  [PageIdStylioArch71.SUBSCRIPTIONS_ARCH_71]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_71/pages/ArchSubscriptionPage').then(
        (m) => ({
          default: m.ArchSubscriptionPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_71/pages/ArchSubscriptionPage'),
  },
  [PageIdStylioArch71.SUB_UPSELL_ARCH_71]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_71/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_71/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioArch71.FACE_STYLING_PDF_UPSELL_ARCH_71]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_71/pages/third-pdf-upsell/ThirdPdfUpsell'
      ).then((m) => ({
        default: m.ThirdPdfUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_71/pages/third-pdf-upsell/ThirdPdfUpsell'
      ),
  },
  [PageIdStylioArch71.PROPORTIONS_PDF_UPSELL_ARCH_71]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_71/pages/ProportionsPdfUpsell').then(
        (m) => ({
          default: m.ProportionsPdfUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_71/pages/ProportionsPdfUpsell'),
  },
  [PageIdStylioArch71.DOWNLOAD_ARCH_71]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_71/pages/download-arch/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_71/pages/download-arch/DownloadDefault'
      ),
  },
}
